/*
 * @dev navigator.share 가 지원되는 환경에서, 클립보드에 복사를 누르거나 공유를 취소했을 때에도 exception 이 울림
 */
export const runNavigatorShare = async ({ title, text, url }: ShareData) => {
  try {
    /**
     * IOS에서 타이틀을 추가해 share를 호출하는 경우 간헐적으로 복사가 title + url로 되는 경우가 존재
     * ex) Discover [리플레이LEEPLAY]'s exclusive merchandise at MarppleShop. https://marpple.shop/en/leeplay
     *
     * 코드 레벨에서 통제 가능한 부분이 아니기 때문에, title을 제외하고 url만 사용하기로 결정 (타이틀을 포기하고 링크 복사를 정확히)
     */
    await navigator.share({
      // title,
      // text,
      url,
    });
  } catch (err) {
    const error = err as DOMException;
    if (error.name !== 'AbortError') throw err;
  }
};
